export function emptyTwoSidedDocument() {
  return {
    front: null,
    back: null,
    pdf: null,
    skipped: false,
  };
}

export function isPdfFile(file) {
  const type = String(file?.mimeType || file?.type || '').toLowerCase();
  const name = String(file?.name || '').toLowerCase();
  return type === 'application/pdf' || name.endsWith('.pdf');
}

export function hasCompleteTwoSidedDocument(value, { photoOnly = false } = {}) {
  if (!value) return false;
  if (value.skipped) return true;
  if (photoOnly) return Boolean(value.front);
  if (value.pdf) return true;
  return Boolean(value.front && value.back);
}

export async function uploadTwoSidedDriverDocument({ verificationId, personId, docType, value, uploadDriverDocument }) {
  if (!value || value.skipped) return;

  if (value.pdf) {
    await uploadDriverDocument(verificationId, personId, docType, value.pdf, 'pdf');
    return;
  }

  if (value.front) await uploadDriverDocument(verificationId, personId, docType, value.front, 'front');
  if (value.back) await uploadDriverDocument(verificationId, personId, docType, value.back, 'back');
}